export class BlogModel {
    id: string;
    imgUrl: string;
    last_update: Date = new Date();
    slug: string;
    title: string;
    content: string;
}